import Link from "next/link";
import { useTranslation } from "next-i18next";
import { handleStartWithSlashInUrl } from "@/utils/global";

const Tabs = ({
  fromCategory,
  active,
  setActive,
  title: updatedTitle,
  tabsTitles: updatedTabsTitles,
  locale,
  handleSwitchTabs,
}) => {
  const { t } = useTranslation("common");

  const title = fromCategory ? "Top Of This Week" : updatedTitle;
  const tabsTitles = fromCategory
    ? fromCategory?.map((item) => ({
        ...item,
        name:
          locale == "ar"
            ? item?.arabic_name || ""
            : item?.english_english || "",
      }))
    : updatedTabsTitles?.map((item) => ({
        ...item,
        name: item[`title-${locale}`] || "",
      }));

  return (
    <div className="flex-wrap gap-3">
      <div className="flex items-center justify-between mb-5">
        <p className="md:text-2xl font-bold text-xl">{title || ""}</p>
        <Link
          href={`/${handleStartWithSlashInUrl(tabsTitles[active]?.url)}`}
          className="block text-xs underline lg:hidden text-secondary-900"
        >
          {t("View All")}
        </Link>
      </div>
      <div className="flex items-center mb-5 md:justify-between">
        <div className="flex items-center md:gap-3 *:whitespace-nowrap max-sm:text-xs overflow-auto gap-2 *:text-center max-sm:*:font-normal  *:rounded-lg">
          {(tabsTitles || [])?.map((tab, idx) => (
            <button
              key={idx}
              onClick={() => {
                setActive(idx);
                handleSwitchTabs &&
                  handleSwitchTabs(tab?.category_id || tab?.id);
              }}
              className={`mb-2 hover:bg-primary font-bold hover:text-white py-2 px-6 transition-all ${
                active === idx ? "bg-primary text-white max-sm:text-xs" : null
              }`}
            >
              {tab?.name || ""}
            </button>
          ))}
        </div>
        <Link
          href={`/${handleStartWithSlashInUrl(tabsTitles[active]?.url)}`}
          className="hidden underline lg:block"
        >
          {t("View All")}
        </Link>
      </div>
    </div>
  );
};

export default Tabs;
